import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles(() => ({
	insuranceIcon: {
		width: 24,
		height: 24,
	},
}));
